import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import type { ItemBusca, Regime } from "../../../shared/tipos";
import { api } from "../api/cliente";
import { useFamilias } from "../api/consultas";
import { useTermoComAtraso } from "../components/useTermoComAtraso";
import { formatarMoeda, semAutocompletar, Tabela } from "../components/ui";

export function Itens() {
  const { data: familias = [] } = useFamilias();
  const [q, setQ] = useState("");
  const [familiaId, setFamiliaId] = useState("");
  const [regime, setRegime] = useState<Regime>("desonerada");
  const termo = useTermoComAtraso(q);

  const { data: resultados = [], isFetching } = useQuery({
    queryKey: ["itens", termo, familiaId, regime],
    queryFn: () =>
      api<ItemBusca[]>(`/api/itens?${new URLSearchParams({ q: termo, familia_id: familiaId, regime })}`),
    placeholderData: (anterior) => anterior,
  });

  return (
    <>
      <h1>Consultar Tabela de Preços</h1>
      <p className="note">
        Busca por código, descrição ou palavra-chave (cada palavra digitada é buscada separadamente, em qualquer ordem, sem
        diferenciar acentos). Apenas variantes já importadas para o banco aparecem aqui (ver Painel).
      </p>

      <div className="card">
        <div className="form-row">
          <label>
            Localizar
            <input type="search" placeholder="código ou descrição..." style={{ minWidth: 280 }} value={q} onChange={(e) => setQ(e.target.value)} {...semAutocompletar} />
          </label>
          <label>
            Família
            <select value={familiaId} onChange={(e) => setFamiliaId(e.target.value)}>
              <option value="">Todas</option>
              {familias.map((f) => (
                <option key={f.id} value={f.id}>
                  {f.nome}
                </option>
              ))}
            </select>
          </label>
          <label>
            Regime
            <select value={regime} onChange={(e) => setRegime(e.target.value as Regime)}>
              <option value="desonerada">Desonerada</option>
              <option value="tradicional">Tradicional</option>
            </select>
          </label>
        </div>
        <Tabela>
          <thead>
            <tr>
              <th>Código</th>
              <th>Descrição</th>
              <th>Classe</th>
              <th>Un.</th>
              <th className="num">Preço (R$)</th>
              <th>Sindicato base</th>
            </tr>
          </thead>
          <tbody>
            {resultados.map((r, i) => (
              <tr key={`${r.id}-${r.sindicato}-${i}`}>
                <td>{r.codigo}</td>
                <td>{r.descricao}</td>
                <td>{r.classe || ""}</td>
                <td>{r.unidade || ""}</td>
                <td className="num">{formatarMoeda(r.preco_unitario)}</td>
                <td>
                  <span className="badge badge-blue">{r.sindicato}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </Tabela>
        <p className="note">
          {isFetching ? "Buscando…" : `${resultados.length} resultado(s) (máx. 100 exibidos)`}
        </p>
      </div>
    </>
  );
}
